module.exports = __webpack_public_path__ + "img/stary_rynek.1a981be1.jpg";